import { useNavigate, useLocation } from "react-router";
import { LandingPageSection } from "../../components/static-page-components/landing-page-section";
import "./styles.scss";
import WestIcon from "@mui/icons-material/West";
import { Box, Button, Grid2, Typography } from "@mui/material";
import comingSoonImage from "../../assets/general/Coming-Soon.jpg";
import { Pages } from "../../utils";

export const ComingSoonPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomeownerPage = location.pathname === Pages.HOMEOWNER_USER_LANDING;

  return (
    <div className="page coming-soon-page">
      <LandingPageSection className="text-center coming-soon-landing">
        {isHomeownerPage && (
          <Grid2 container>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box pt={14} textAlign={"left"}>
                <Typography
                  variant={"display2" as any}
                  className="font-size-7 font-title"
                  component="h1"
                  sx={{
                    mb: "32px",
                  }}
                >
                  Coming Soon!
                </Typography>
                <Typography
                  variant="body1"
                  className="section-subtitle font-size-4"
                >
                   We’re currently vetting and onboarding interior designers and
                  decorators across the country. Please fill out the form below
                  to be alerted when we launch in your town!
                </Typography>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <iframe
                src="https://crm.homedesignguild.com/widget/survey/KIwYx6wBrgXETBYwNCgk"
                style={{
                  border: "none",
                  width: "100%",
                  height: "1200px",
                }}
                scrolling="no"
                id="KIwYx6wBrgXETBYwNCgk"
                title="Homeowner Lead Capture"
              ></iframe>
              <script src="https://crm.homedesignguild.com/js/form_embed.js"></script>
            </Grid2>
          </Grid2>
        )}
        {!isHomeownerPage && (
          <Box>
            <Typography
              variant={"display2" as any}
              className="font-size-7 font-title"
              component="h1"
              sx={{
                mb: "32px",
              }}
            >
              Coming Soon!
            </Typography>
            <Typography
              variant="body1"
              className="section-subtitle font-size-4"
            >
              We're actively building powerful new features to revolutionize
              your interior design workflow. This page is currently under
              construction as we meticulously craft tools that will enhance your
              business and efficiency.
            </Typography>
            <Button
              onClick={() => navigate(-1)}
              variant="contained"
              size="large"
              startIcon={<WestIcon />}
            >
              Go Back
            </Button>
          </Box>
        )}
      </LandingPageSection>

      <img
        src={comingSoonImage}
        alt="this section is coming soon!"
        className="full-width-image"
      />
    </div>
  );
};
